export const modernChatStyles = {
  chatContainer: {
    backgroundColor: "#FFFFFF",
  },
  messagesContainer: {
    padding: "8px",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column" as const,
    backgroundColor: "#FFFFFF",
    flexShrink: 0,
    padding: "0px",
    borderRadius: "12px",
    border: "1px solid #d1d1d1",
    overflow: "visible", // Keep this for your dropdowns
    // Add this to create a proper stacking context for dropdowns
    position: "relative" as const,
  },

  insertButtonContainer: {
    padding: "8px 12px 8px 12px",
    borderBottom: "1px solid #f0f0f0",
    // Ensure the insert button area respects the top corners
    borderRadius: "12px 12px 0 0", // Top corners match container
  },

  insertButton: {
    width: "100%",
    padding: "10px 16px",
    backgroundColor: "#0078d4",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "background-color 0.2s",
    fontSize: "13px",
    textAlign: "center" as const,
  },

  // This is the key fix - make the textarea respect the container's shape
  inputField: {
    width: "100%",
    margin: "0",
    padding: "10px 12px 6px 12px",
    border: "none",
    // CRITICAL FIX: Apply border-radius to match container corners
    borderRadius: "12px 12px 0 0", // Top corners rounded, bottom corners square
    resize: "none" as const,
    overflowY: "auto" as const,
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "14px",
    outline: "none",
    backgroundColor: "#FFFFFF",
    color: "#333333",
    lineHeight: "1.5",
    boxSizing: "border-box",
    // Handle placeholder color properly with CSS-in-JS
    "&::placeholder": {
      color: "#777777",
    },
  },

  actionBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "2px 12px 6px 12px",
    borderTop: "none",
    // CRITICAL FIX: Apply border-radius to match container's bottom corners
    borderRadius: "0 0 12px 12px", // Bottom corners rounded, top corners square
    backgroundColor: "#FFFFFF", // Ensure consistent background
  },

  actionBarLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  actionBarRight: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },

  agentSelector: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 0px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontFamily: "'Segoe UI', sans-serif",
    fontWeight: "400",
    color: "black",
    // Add relative positioning for dropdown positioning
    position: "relative" as const,
  },

  agentDropdown: {
    position: "absolute" as const,
    bottom: "calc(100% + 8px)",
    right: 0,
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    zIndex: 100,
    width: "200px",
    border: "1px solid #E0E0E0",
    overflow: "hidden",
  },

  agentOption: {
    padding: "10px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none",
    },
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },

  agentName: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  agentDescription: {
    fontSize: "12px",
    color: "#757575",
    marginTop: "2px",
  },

  sendButton: {
    backgroundColor: "#0A8CBB",
    color: "white",
    border: "none",
    borderRadius: "4px",
    padding: "0px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    transition: "opacity 0.2s, background-color 0.2s",
    "&:hover": { backgroundColor: "#d17c7c" },
  },

  sendButtonSpinner: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: "2px solid white",
    borderTopColor: "transparent",
    animation: "spin 1s linear infinite",
  },
};
